import { Controller } from "@hotwired/stimulus"

// 確定日時（開始・終了）を一体で管理するコントローラー。
// 1 つの日付 input と 2 セットの時刻 select を組み合わせ、
// 開始・終了それぞれの hidden input に datetime-local 形式で同期する。
export default class extends Controller {
  static targets = [
    "date",
    "startHour", "startMinute", "startHidden",
    "endHour", "endMinute", "endHidden"
  ]

  sync() {
    const date = this.dateTarget.value
    const startHour = this.startHourTarget.value
    const startMin = this.startMinuteTarget.value
    const endHour = this.endHourTarget.value
    const endMin = this.endMinuteTarget.value

    const startValue = date && startHour !== "" && startMin !== "" ? `${date}T${startHour}:${startMin}` : ""
    const endValue = date && endHour !== "" && endMin !== "" ? `${date}T${endHour}:${endMin}` : ""

    this.#dispatchHidden(this.startHiddenTarget, startValue)
    this.#dispatchHidden(this.endHiddenTarget, endValue)
  }

  // 外部から開始時間をセット（auto-fill・broadcast 受信時）
  setStartTime(datetime) {
    this.#applyDatetime(datetime, "start")
  }

  // 外部から終了時間をセット（auto-fill・broadcast 受信時）
  setEndTime(datetime) {
    this.#applyDatetime(datetime, "end")
  }

  #applyDatetime(datetime, prefix) {
    if (!datetime) {
      if (prefix === "start") {
        this.startHourTarget.value = ""
        this.startMinuteTarget.value = ""
        this.#dispatchHidden(this.startHiddenTarget, "")
      } else {
        this.endHourTarget.value = ""
        this.endMinuteTarget.value = ""
        this.#dispatchHidden(this.endHiddenTarget, "")
      }
      return
    }
    const [datePart, timePart] = datetime.split("T")
    if (datePart) this.dateTarget.value = datePart
    if (timePart) {
      const [h, rawM] = timePart.split(":")
      const minutes = parseInt(rawM, 10)
      let rounded = isNaN(minutes) ? "" : String(Math.min(Math.round(minutes / 15) * 15, 45)).padStart(2, "0")
      if (prefix === "start") {
        this.startHourTarget.value = h || ""
        this.startMinuteTarget.value = rounded
      } else {
        this.endHourTarget.value = h || ""
        this.endMinuteTarget.value = rounded
      }
    }
    this.sync()
  }

  #dispatchHidden(hiddenInput, value) {
    if (hiddenInput.value !== value) {
      hiddenInput.value = value
      hiddenInput.dispatchEvent(new Event("input", { bubbles: true }))
      hiddenInput.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
